import { Link } from 'react-router-dom';

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="inline-flex items-center" aria-label="GangaCars, inicio">
      <img
        src="/assets/gangacars-logo.png"
        className={compact ? 'h-11 w-auto sm:h-12' : 'h-20 w-auto'}
        alt="GangaCars · Coches, mejores precios"
      />
    </Link>
  );
}
